import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ChevronDown, ChevronUp } from "lucide-react";

const ServiceArea = [
  { label: "Şirinevler Koltuk Yıkama", path: "/bahcelievler/sirinevler-koltuk-yikama" },
  { label: "Şirinevler Perde Yıkama", path: "/bahcelievler/sirinevler-perde-yikama" },
  { label: "Yenibosna Koltuk Yıkama", path: "/bahcelievler/yenibosna-koltuk-yikama" },
  { label: "Yenibosna Yatak Yıkama", path: "/bahcelievler/yenibosna-yatak-yikama" },
  { label: "Kocasinan Koltuk Yıkama", path: "/bahcelievler/kocasinan-koltuk-yikama" },
  { label: "Kocasinan Yorgan Yıkama", path: "/bahcelievler/kocasinan-yorgan-yikama" },
  { label: "Siyavuşpaşa Koltuk Yıkama", path: "/bahcelievler/siyavuspasa-koltuk-yikama" },
  { label: "Siyavuşpaşa Battaniye Yıkama", path: "/bahcelievler/siyavuspasa-battaniye-yikama" },
  { label: "Fevzi Çakmak Koltuk Yıkama", path: "/bahcelievler/fevzi-cakmak-koltuk-yikama" },
  { label: "Fevzi Çakmak Yerinde Yıkama", path: "/bahcelievler/fevzi-cakmak-yerinde-yikama" },
  { label: "Bahçelievler Merkez Kuru Temizleme", path: "/bahcelievler/merkez-kuru-temizleme" }
];

const BahcelievlerServiceArea = () => {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="text-[#003132] mt-0 w-full">
      <div
        onClick={toggleDropdown}
        className="cursor-pointer flex items-center justify-between bg-[#e2e8f0] p-3 rounded-lg shadow-md hover:bg-[#d1d5db]"
      >
        <h2 className="text-lg font-semibold uppercase tracking-wide">
          BAHÇELİEVLER HİZMET TÜRLERİ
        </h2>
        {isOpen ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
      </div>

      {isOpen && (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 gap-3 bg-[#f1f5f9] p-5 rounded-xl shadow-sm border border-gray-200 w-full mt-2">
          {ServiceArea.map((area, index) => (
            <Link
              key={index}
              to={area.path}
              className={`text-sm font-semibold px-4 py-3 rounded-lg text-center transition-all duration-200 ${
                location.pathname === area.path
                  ? "bg-green-700 text-white"
                  : "bg-white text-green-900 hover:bg-green-100 hover:text-green-800"
              }`}
            >
              {area.label}
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};

export default BahcelievlerServiceArea;
